import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { ReactNode } from "react";
type IconButtonProps = {
  src?: string;
  alt?: string;
  width?: number;
  height?: number;
  onClick: () => void;
  className?: string;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  children?: ReactNode;
};
const IconButton = t0 => {
  const $ = _c(14);
  const {
    src,
    alt,
    width: t1,
    height: t2,
    onClick,
    className,
    disabled,
    type: t3,
    children
  } = t0;
  const width = t1 === undefined ? 24 : t1;
  const height = t2 === undefined ? 24 : t2;
  const type = t3 === undefined ? "button" : t3;
  if (!src && !children) {
    throw new Error("IconButton requires either 'src' or 'children' prop");
  }
  const t4 = `dynamic-size relative cursor-pointer ${className} `;
  let t5;
  if ($[0] !== height || $[1] !== width) {
    t5 = {
      "--width": width,
      "--height": height
    };
    $[0] = height;
    $[1] = width;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const t6 = t5 as React.CSSProperties;
  let t7;
  if ($[3] !== alt || $[4] !== children || $[5] !== src) {
    t7 = children ? children : <Image src={src} alt={alt} fill={true} className="object-contain" />;
    $[3] = alt;
    $[4] = children;
    $[5] = src;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== disabled || $[8] !== onClick || $[9] !== t4 || $[10] !== t6 || $[11] !== t7 || $[12] !== type) {
    t8 = <button className={t4} disabled={disabled} type={type} onClick={onClick} style={t6}>{t7}</button>;
    $[7] = disabled;
    $[8] = onClick;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
    $[12] = type;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};
export default IconButton;